import { IS_CLIENT } from '../constants';
const setCookie = (name, value, hours = 24, domain = '', secure = false) => {
    const now = Date.now();
    const expires = new Date();
    expires.setTime(now + 1000 * 60 * 60 * hours);
    let cookieSignature = '';
    if (IS_CLIENT) {
        cookieSignature = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
        if (domain) {
            cookieSignature += `; domain=${domain}`;
        }
        if (secure) {
            cookieSignature += '; secure=true';
        }
        document.cookie = cookieSignature;
    }
    return null;
};
export default setCookie;
//# sourceMappingURL=setCookie.js.map